import { render } from "./WidgetPickerModal.vue?vue&type=template&id=59281df4&scoped=true"
import script from "./WidgetPickerModal.vue?vue&type=script&lang=js"
export * from "./WidgetPickerModal.vue?vue&type=script&lang=js"

import "./WidgetPickerModal.vue?vue&type=style&index=0&id=59281df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59281df4"]])

export default __exports__